// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".page404{color:rgba(var(--pcse-color-white),1)}", "",{"version":3,"sources":["/home/jenkins/agent/workspace/dashboard_gsa/src/views/404.vue"],"names":[],"mappings":"AAqBA,SACE,qCAAA","file":"404.vue","sourcesContent":["@import \"@/styles/_variables.scss\";\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.page404 {\n  color: color(\"white\");\n}\n"]}]);
// Exports
module.exports = exports;
